export default __webpack_public_path__ + "static/media/pFTM.71e529ff.svg";